const ApiConstants = {
  loginUserUrl: "api/user/user-login/",

  otpVerificationUrl: "api/auth/verify-otp",

  userUrl: "api/user",
  deleteUserUrl: "api/user/delete-user",
  createUserUrl: "api/user/",
  updateUserUrl: "api/user/update-user/",
  getAllBrandsUrl: "api/user/get-all-manufacturer",
  getCategoriesByBrandUrl: "api/products/get-category-by-brandId",
  getLoggedInUserDetailsUrl: "api/user/get-user-detail",
  becomeAManufacturerUrl: "api/contact-us/manufacturer-inquiry",
  getUserByRoleIdUrl: "api/user/get-user-by-roleId",
  getUserRolesUrl:"api/global/user-role",
  getUserStatusUrl:"api/global/user-status",

  getUserAdditionalInfoQuestionUrl:
    "api/userAdditional-information/user-questions",
  addUserAdditionalInfoAnswerValueUrl:
    "api/userAdditional-information/user-add-answers",

  productUrl: "api/product",
  createProductUrl: "api/products/product",
  productMeltingByStampUrl: "api/products/get-stamp-purity",
  getAllCategoryByUserIdUrl: "api/products/get-AllCategory-by-manufactureId",

  updateProductQuantityUrl: "api/products/quantity",
  productByManufactureIdUrl: "api/products/get-product-by-manufacturer",

  productMetalUrl: "api/product-metal",
  getMetalColorUrl: "api/global/color-stone",
  productCategoryUrl: "api/product-category",

  productCategoryByCategoryNameUrl: "api/product-category",

  productCategoryAssignmentUrl:"api/product-category-assignment",

  // productMetalPurityUrl: "api/product-metal-purity",
  productMetalPurityUrl: "api/global/stamp-melting",

  getRoleUrl: "api/role",

  rolePermissionUrl: "api/role-permission",

  userRolePermissionUrl: "api/user-role-permission",

  userRolePermissionByLoggedInUserUrl:
    "api/user-role-permission/get-roles-by-loggedInuser",

  getAllModuleUrl: "api/module/get-all-module",
  getAllOrderUrl: "api/order/get-all-orders",
  getAllOrderStatusAUrl: "api/global/order-status",
  getOrderByManufactureIdUrl: "api/order/get-orders-manufactureId",
  createOrderUrl: "api/order",
  createPreOrderUrl: "api/order/create-pre-order",
  updateOrderStatusUrl: "api/order",
  orderTrackingUrl:"api/order/order-tracking",
  createFeedbackUrl: "api/feedback",
  updateFeedbackUrl: "api/feedback",
  getFeedBackRatingReviewUrl: "api/feedback",
  getFeedbackTypeUrl: "api/global/feedback-type",

  dashboardUrl: "api/dashboard",
  menuUrl: "api/menu",

  pageUrl: "api/page",

  getAllPageUrl: `api/page/get-all-pages`,

  logoutUserUrl: "/api/auth/logout",

  createFileStorageUrl: "api/file-storage/file-storage",

  fileStorageUrl: "api/file-storage/file-storage",

  // Home page
  getLandingPageContentUrl: "api/page/home-page",

  //wishlist URL
  wishlistUrl: "api/wishlist",
  // addWishlistUrl: 'api/wishlist',

  //cart URL
  cartUrl: "api/cart",
  cartBrandUrl: "api/cart/brand",
  cartTotalUrl: "api/cart/get-total",

  //orders URL
  myOrdersUrl: "api/order",
  //pin code (getting city,state,district)
  getCityStateDistrictByPinCodeUrl: "api/address",

  //Address URL
  getAddressListsUrl: "api/address",
  createAddressListUrl: "api/address",
  updateAddressListUrl: "api/address/update-user-address",
  deleteAddressListUrl: "api/address/delete-user-address",

  //user additional questions URL
  getUserAddidtionalQuestionsUrl: "api/user-additional-information",
  addUserAddidtionalInfoUrl: "api/user-additional-information",
  getUserDetailsInOnboardingUrl:
    "api/user-additional-information/user-additional-information-data",

  //subscription URL
  subscriptionUrl: "api/subscription",

  // global search url
  searchUrl: "api/global/global-search",

  getActiveSubscriptionUrl: "api/subscription",
  AddSubscriptionUrl: "api/subscription/",
  updateSubscriptionUrl: "api/subscription/update-subscription",

  getGlobalGenericNameUrl: "api/global/get-generic-type-data",
  createGenericDataUrl: "api/user/create-generic-data",

  //wallet url
  walletTransactionUrl: "api/transaction/get-transaction",
  addWalletTransactionUrl: "api/transaction/addTransaction",
  createWalletUrl: "api/transaction/create-wallet",
  applyWalletCheckUrl: "api/cart/apply-wallet",
  latestWalletTransactionUrl: "api/transaction/get-user-latest-transaction",

  //global filter url
  globalFilterUrl: "api/global/global-filter",
  getUserAddressByIdUrl: "api/address/get-user-address-by-id",
  getUserAddressTypeUrl: "api/global/address-type",
  updateDefaultAddressUrl: "api/address/",

  //transport url
  getTransportUrl: "api/transport/get-all-transport",
  createTransportUrl: "api/transport/create-transport",
  updateTransportUrl: "api/transport/update-transport",
  deleteTransportUrl: "api/transport/delete-transport",
  // deleteTransportUrl: "api/transport/delete-transport",

  //transaction url
  getUserTransactionsAPI:"api/transaction/get-transaction",
  reInitiateTransactionAPI:"api/transaction/manual-transaction",
  contactUsUrl: "api/contact-us",
  liveRateDataURL:"api/live-rate",
  getTransactionTypeURL:"api/global/transaction-type",
  getTransactionStatusURL: "api/global/transaction-status",
  getTransactionSummaryURL:"api/transaction",

  //payment url 
  paymentVerificationUrl:"api/transaction/payment-verify",
  paymentMethodUrl:"api/global/payment-method",
  paymentGatewayUrl:"api/global/payment-gateway",
  paymentStageUrl:"api/global/payment-stage",

  //bank url
  bankAccountUrl:"api/bank-account",

  //reward point
  getRewardPointsAPI:"api/reward-point",
  getMilestonesAPI:"api/reward-point/milestone",
  getRewardPointUnitsAPI:"api/reward-point/get-reward-point-units",
  getOrdersByRewardPointsAPI:"api/reward-point/get-all-order",
  getReferralsAPI:"api/transaction/get-referrals",
};

export default ApiConstants;
